var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    role: "img",
    "aria-label": "Z\\xE9 Praga",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#C8F169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17V10h7M31 10h7v7M38 31v7h-7M17 38h-7v-7",
    stroke: "#0F1A13",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33c0-11 7-18 18-18 0 11-7 18-18 18z",
    fill: "#1B4D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33l10-10",
    stroke: "#C8F169",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarca);
export default __webpack_public_path__ + "static/media/marca.1d111dae379ff88533ee8d758b6d1101.svg";
export { ForwardRef as ReactComponent };